module.exports = __webpack_public_path__ + "static/media/16.4774d7c1.jpg";